module.exports = __webpack_public_path__ + "assets/img/returnBtn-d2a6b480.png";